import Constants from './constants.json';
import { getAvatarDomain as _getAvatarDomain } from 'a_common-folder/utils/avatar';

export const extractRoomId = (str) => {
  try {
    if (str.startsWith('"') && str.endsWith('"')) {
      str = str.slice(1, -1);
    }

    str = str.replace(/\\"/g, '"');

    const match = str.match(/\[\[move:\s*"?(\\?\d+)"?\]\]/);
    return match ? match[1] : '';
  } catch (e) {
    return null;
  }
}

export const extractInfoId = (str) => {
  try {
    if (!str) return null;

    // Trim and clean leading/trailing quotes
    str = str.trim();
    if (str.startsWith('"') && str.endsWith('"')) {
      str = str.slice(1, -1);
    }

    // Normalize escaped characters and common format errors
    str = str
      .replace(/\\"/g, '"')                       // unescape quotes
      .replace(/\s+/g, ' ')                       // normalize spaces
      .replace(/hotspot\s*ID/gi, 'hotspotID')     // normalize hotspotID key
      .replace(/\s*-\s*/g, '-')                   // remove spaces around hyphens
      .trim();

    // Extract hotspotID value separately and remove internal spaces inside UUID
    const hotspotMatch = str.match(/hotspotID:\s*"([^"]+)"/i);
    if (hotspotMatch) {
      const cleanedHotspotID = hotspotMatch[1].replace(/\s+/g, '');
      str = str.replace(hotspotMatch[0], `hotspotID: "${cleanedHotspotID}"`);
    }

    // Main regex to match move and optional hotspotID
    const match = str.match(/\[\[move:\s*"(\d+)"(?:,\s*hotspotID:\s*"([A-Za-z0-9-]+)")?\]\]/);

    if (match) {
      return {
        sceneID: Number(match[1]),
        hotspotID: match[2] || null
      };
    }

    return null;
  } catch (e) {
    console.error('extractInfoId error:', e);
    return null;
  }
};

export const extractModeID = (str) => {
  try {
    if (str.startsWith('"') && str.endsWith('"')) {
      str = str.slice(1, -1);
    }

    str = str.replace(/\\"/g, '"');

    const match = str.match(/\[\[mode:\s*"([^"]+)"\]\]/);
    return match ? match[1] : '';
  } catch (e) {
    return null;
  }
}

export const getAvatarDomain = _getAvatarDomain;
